// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ReactModal from "react-modal";
import ReactMarkdown from "react-markdown";
import * as VideoPlaybackModal from "./VideoPlaybackModal.bs.js";
import * as PartnerScoreAssetConfig from "../assets/PartnerScoreAssetConfig.bs.js";

function ScoreDetailsModal(Props) {
  var modal_state = Props.modal_state;
  var content = Props.content;
  var close_modal = Props.close_modal;
  var isModalOpen = Props.isModalOpen;
  var match = React.useState(function () {
        return false;
      });
  var setShowVideo = match[1];
  var _val = content.video_url;
  return React.createElement(ReactModal, {
              isOpen: Curry._1(isModalOpen, modal_state),
              onRequestClose: close_modal,
              className: "c-score-details-modal",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: null
            }, React.createElement("div", {
                  className: "c-score-details-modal__close-btn",
                  onClick: (function (param) {
                      return Curry._1(close_modal, undefined);
                    })
                }, React.createElement("img", {
                      className: "c-score-details-modal__close-icon",
                      src: PartnerScoreAssetConfig.close_icon
                    })), React.createElement("div", {
                  className: "c-score-details-modal__container"
                }, React.createElement("div", {
                      className: "c-score-details-modal__header"
                    }, React.createElement("div", {
                          className: "c-score-details-modal__title"
                        }, content.question)), React.createElement("div", {
                      className: "c-score-details-modal__content"
                    }, _val !== undefined ? React.createElement("div", {
                            className: "c-score-details-modal__video",
                            onClick: (function (param) {
                                return Curry._1(setShowVideo, (function (param) {
                                              return true;
                                            }));
                              })
                          }, React.createElement("img", {
                                src: PartnerScoreAssetConfig.video_icon
                              })) : null, React.createElement("div", {
                          className: "c-score-details-modal__text"
                        }, React.createElement(ReactMarkdown, {
                              children: content.answer
                            })), React.createElement(VideoPlaybackModal.make, {
                          link: Belt_Option.getWithDefault(content.video_url, ""),
                          close_modal: (function (param) {
                              return Curry._1(setShowVideo, (function (param) {
                                            return false;
                                          }));
                            }),
                          show_modal: match[0]
                        }))));
}

var make = ScoreDetailsModal;

export {
  make ,
  
}
/* react Not a pure module */
